import dayjs from "dayjs";

const commonJs = {

    compareArrays(a, b) {
        /* 약관동의 필수 체크 (필수외에도 있을수있어서) */
        if (a.length <= b.length) {
            return a.every((item, i) => b.includes(item));
        } else {
            return false;
        }
    },
    isEmpty(value) {
        if (value === undefined || value === null || value === "") {
            return true
        } else {
            return false;
        }
    },
    deepUpdate(obj1, obj2) {
        for (var prop in obj2) {
            try {
                if (obj2[prop].constructor === Object) {
                    obj1[prop] = this.deepUpdate(obj1[prop], obj2[prop]);
                } else if (obj1.hasOwnProperty(prop)) {
                    obj1[prop] = obj2[prop];
                }
            } catch (e) {
                obj1[prop] = obj2[prop];
            }
        }
        return obj1
    },
    getFormData() {
        const formData = new FormData(this.$refs['form']);
        const data = {};
        for (let [key, val] of formData.entries()) {
            Object.assign(data, {[key]: val});
        }
        return data;
    },
    getData(obj, test = false) {
        let data = {}
        Object.entries(obj).forEach(([key, val]) => {
            if (test) {
                Object.assign(data, {[key]: val});
            } else {
                data[key] = val;
                // if(this.isEmpty(data[key])) {
                //     data[key] = "";
                // } else {
                //     data[key] = val;
                // }
            }
        })
        return data;
    },
    getAge(birthday) {
        if (birthday != null) {
            const birthDate = new Date(dayjs(birthday).format("YYYY-MM-DD"));
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        } else {
            return 0;
        }
    },
    checkJumin(value) {
        var rule = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-8][0-9]{6}$/
        if (!rule.test(value)) {
            return false;
        }
        return true;
    },
    checkPhonNumber(value) {
        const phoneRegex = /^(010-\d{4}-\d{4}|010\d{8}|011-\d{3}-\d{4}|011\d{7}|010[\d\D]{3,4}\d{4}})$/g;
        return phoneRegex.test(value);
    },
    getIdNum(value, type = 'dash') {
        let changeValue = value;
        let returnValue = "";
        if (type === 'dash') {
            returnValue = changeValue.replace(/[^0-9]/g, "").replace(/^(\d{0,6})(\d{0,7})$/g, "$1-$2").replace(/-{1,2}$/g, "");
        } else if (type === 'mask') {
            returnValue = changeValue.replace(/-/g, "").replace(/^(\d{6})(\d{1})(\d{6})/, "$1-$2******");
        } else {
            returnValue = "";
        }
        return returnValue;
    },

    // 모바일, 웹 구분 (true, false 반환)
    isMobileDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());

    },
    regCheck_NameEmptyText(value) {
        /*중간공백 허용, 마지막,시작공백X */
        const reg = /^[a-zA-Z가-힣]+(?:\s[a-zA-Z가-힣]*)*[a-zA-Z가-힣]$/;
        return (!reg.test(value))
    },
    // 게시물 등록일자가 오늘일자 기준으로 1일 이내인경우 NEW아이콘을 띄우기위한 함수
    isNew(date) {
        const postDateObj = new Date(date);
        const today = new Date();
        const differenceInTime = today.getTime() - postDateObj.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        return differenceInDays <= 1;
    },
    isLogoSvg(code) {
        if (code === 'L01' || code === 'L02' || code === 'L03' || code === 'L72' || code === 'L80' || code === 'M72') {
            return true;
        } else {
            return false;
        }
    },

    createUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

export default commonJs